<template>
  <DetailList>
    <DetailListHeader title="Court" />
    <DetailListItem title="Right Witness" :figureIndex="13" />
    <DetailListItem title="Left Witness" :figureIndex="14" />
    <DetailListItem title="Judge" :figureIndex="15" />
    <DetailListItem title="Sentence" :figureIndex="16" />
    <DetailListItem title="Sum (96)" :alt="sum" />

    <DetailListHeader title="Triplicities/Triads" />
    <Triplicity title="1st" :right="1" :left="2" :judge="9" />
    <Triplicity title="2nd" :right="3" :left="4" :judge="10" />
    <Triplicity title="3rd" :right="5" :left="6" :judge="11" />
    <Triplicity title="4th" :right="7" :left="8" :judge="12" />

    <ViaPuncti title="Via Puncti Ignis" element="fire" />
    <ViaPuncti title="Via Puncti Aeris" element="air" />
    <ViaPuncti title="Via Puncti Aquae" element="water" />
    <ViaPuncti title="Via Puncti Terrae" element="earth" />
  </DetailList>
</template>

<script>
import DetailList from "./DetailList.vue";
import DetailListItem from "./DetailListItem.vue";
import DetailListHeader from "./DetailListHeader.vue";
import Triplicity from "./Triplicity.vue";
import ViaPuncti from "./ViaPuncti.vue";

import names from "../utils/names";

export default {
  name: "ShieldList",
  components: {
    DetailList,
    DetailListItem,
    DetailListHeader,
    Triplicity,
    ViaPuncti
  },
  methods: {
    figureName(figId) {
      const fig = this.$store.getters.getFigureById(figId);
      return names.getNameForFigure(fig);
    }
  },
  computed: {
    sum() {
      return `${this.$store.getters.getSum}`;
    }
  }
};
</script>
